module.exports = __webpack_public_path__ + "img/thumbnail_AldabraGiantTortoise_f_albino.b2fc9345.png";